'use strict';

const { Component, h } = require('phy');

const getLabel = ({ optionsMsrpHash, option }) => {
  const obj = optionsMsrpHash[option];
  return obj ? obj.label : '';
};

const getInlineStyle = label => (!label ? { display: 'none' } : {});

class MSRPLabel extends Component {
  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    if (window.GIG && window.GIG.Tooltip) {
      window.GIG.Tooltip.init(this.base);
    }
  }

  render() {
    const label = getLabel(this.props);
    const style = getInlineStyle(label);

    return h(
      'span.source-metadata-label.tooltip-trigger.msrp-tooltip-trigger',
      {
        'data-position': 'left',
        'data-tooltip-id': 'value-source-metadata',
        style,
      },
      label
    );
  }
}

module.exports = MSRPLabel;
